// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"styles_bannerWrapper__1Om9i","bannerContainer":"styles_bannerContainer__39_ME","logoCircle":"styles_logoCircle__2w591","title":"styles_title__3DPLq"};